import { render, staticRenderFns } from "./PremiumIndicator.vue?vue&type=template&id=4c79c2e5&scoped=true&"
import script from "./PremiumIndicator.vue?vue&type=script&lang=js&"
export * from "./PremiumIndicator.vue?vue&type=script&lang=js&"
import style0 from "./PremiumIndicator.vue?vue&type=style&index=0&id=4c79c2e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c79c2e5",
  null
  
)

export default component.exports